@if (task) {
    <div class="flex items-center gap-1.5">
        <p-checkbox
            [ngModel]="isCompleted()"
            (ngModelChange)="onCheckboxChange($event)"
            [binary]="true"
        ></p-checkbox>
        <!-- Active task indicators - always show -->
        @if (task.assignedEmployee) {
            <phx-avatar
                [employee]="task.assignedEmployee"
                size="small"
                shape="square"
            ></phx-avatar>
        }
        @if (isOverdue()) {
            <i 
                class="fas fa-exclamation-triangle text-red-600 dark:text-red-400 text-sm animate-pulse"
                [pTooltip]="'task.overdue' | translate"
            ></i>
        }
    </div>
}

